module.exports = __webpack_public_path__ + "static/media/cv-joints-and-cv-axles-red.d60e6a3d.svg";